import React from 'react';
import TenantAdminPage from '../../features/tenant-admin/pages/TenantAdminPage';

const AdminTenantAdmin = () => <TenantAdminPage />;

export default AdminTenantAdmin;


